import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React, { useContext } from 'react';
import { Button } from 'semantic-ui-react';
import _get from 'lodash/get';
import { Event } from '../../../../../analytics/components';
import { EVENT_CATEGORIES, EVENT_ACTIONS } from '../../../../../analytics/components/Event';
import { DynamicFormContext } from '../../context/DynamicFormContext';
function DynamicFormSubmitButton() {
  var _useContext = useContext(DynamicFormContext),
    event = _useContext.event,
    submitButtonProps = _useContext.submitButtonProps,
    isFormDisabled = _useContext.isFormDisabled,
    initializeFormData = _useContext.initializeFormData,
    displayErrors = _useContext.displayErrors,
    isFormValid = _useContext.isFormValid,
    loading = _useContext.loading;
  var label = submitButtonProps.label,
    fluid = submitButtonProps.fluid;
  var eventWithDefaultSubmitAction = _objectSpread({
    category: _get(event, 'category', EVENT_CATEGORIES.CONTACT_EVENT_CATEGORY),
    action: _get(event, 'action', EVENT_ACTIONS.CONTACT_SUBMIT_INQUIRY_EVENT_ACTION)
  }, event || {});
  return /*#__PURE__*/React.createElement(React.Fragment, null, !isFormDisabled && /*#__PURE__*/React.createElement(Event, {
    eventType: "click",
    event: eventWithDefaultSubmitAction
  }, /*#__PURE__*/React.createElement(Button, {
    primary: true,
    fluid: fluid,
    disabled: loading || displayErrors && !isFormValid
  }, label)), isFormDisabled && /*#__PURE__*/React.createElement(Button, {
    onClick: initializeFormData,
    primary: true,
    fluid: fluid
  }, "Send Another Message"));
}
export default DynamicFormSubmitButton;